module.exports = __webpack_public_path__ + "img/upload.9efc6caa.png";